<div class="table-view-list">
    <div class="top-row-container">
        <div class="add-new-button">
            <app-button
                [buttonType]="'secondary'"
                [leftIcon]="'plus'"
                [disabled]="statusFilter !== 'Draft'"
                [label]="'blueprintList.button.new' | translate"
                (clickEmitter)="openNameDialog($event)"
            ></app-button>
        </div>

        <mat-radio-group
            class="published-toggle"
            [(ngModel)]="statusFilter"
            (change)="updateFilteredBlueprints($event)">

            @for (status of statusOptions; track status) {
                <mat-radio-button [value]="status">
                    {{ "blueprintList.column.status." + status | translate }}
                </mat-radio-button>
            }
        </mat-radio-group>
    </div>

    <table mat-table [dataSource]="filteredBlueprintItems" class="mat-elevation-z0" multiTemplateDataRows matSort
           (matSortChange)="sortChange($event)">

        <ng-container matColumnDef="groupId">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "blueprintList.column.group" | translate }}</th>
            <td mat-cell *matCellDef="let blueprint" [ngClass]="{'clickable': blueprint?.portalVariants?.length > 0}">
                {{ blueprint.groupId }}
            </td>
        </ng-container>

        <ng-container matColumnDef="status.version">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "blueprintList.column.version" | translate }}</th>
            <td mat-cell *matCellDef="let blueprint" [ngClass]="{'clickable': blueprint?.portalVariants?.length > 0}">
                {{ blueprint.status.version }}
            </td>
        </ng-container>

        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "blueprintList.column.id" | translate }}</th>
            <td mat-cell *matCellDef="let blueprint" [ngClass]="{'clickable': blueprint?.portalVariants?.length > 0}">
                {{ blueprint.id }}
            </td>
        </ng-container>

        <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ "blueprintList.column.name" | translate }}</th>
            <td mat-cell *matCellDef="let blueprint" [ngClass]="{'clickable': blueprint?.portalVariants?.length > 0}">
                {{ blueprint.name }}
            </td>
        </ng-container>

        <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef>{{ "blueprintList.column.action" | translate }}</th>
            <td mat-cell *matCellDef="let blueprint" [ngClass]="{'clickable': blueprint?.portalVariants?.length > 0}">
                <div class="container">
                    @if (this.statusFilter === 'Published' && blueprint.status.__typename === 'Published') {
                        <button
                            mat-button
                            class="table-button"
                            [matTooltip]="'blueprintList.tooltips.archive' | translate"
                            (click)="archiveBlueprint($event, blueprint)">
                            <mat-icon class="icon">delete_outline</mat-icon>
                        </button>
                    }

                    @if (this.statusFilter !== 'Archived' && blueprint.status.__typename === 'Draft') {
                        <button
                            mat-button
                            class="table-button"
                            [matTooltip]="'blueprintList.tooltips.delete' | translate"
                            (click)="deleteBlueprint($event, blueprint)">
                            <mat-icon class="icon">delete_outline</mat-icon>
                        </button>
                    }

                    @if (this.statusFilter !== 'Archived' && blueprint.status.__typename === 'Draft') {
                        <button
                            mat-button
                            class="table-button"
                            [matTooltip]="'blueprintList.tooltips.publish' | translate"
                            (click)="publishBlueprint($event, blueprint)">
                            <mat-icon class="icon">publish</mat-icon>
                        </button>
                    }

                    @if (blueprint.status.__typename !== 'Draft') {
                        <button
                            mat-button
                            class="table-button"
                            [matTooltip]="'blueprintList.tooltips.copy' | translate"
                            (click)="openCopyBlueprintDialog($event, blueprint)">
                            <mat-icon class="icon">content_copy</mat-icon>
                        </button>
                    }

                    @if (blueprint.status.__typename === 'Draft') {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'blueprintList.tooltips.editJson' | translate"
                                (click)="openEditBlueprintJsonDialog($event, blueprint)">
                            <mat-icon class="icon">data_object</mat-icon>
                        </button>
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'blueprintList.tooltips.editForm' | translate"
                                (click)="openEditBlueprintFormDialog(blueprint)">
                            <mat-icon class="icon">edit</mat-icon>
                        </button>
                    } @else {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'blueprintList.tooltips.view' | translate"
                                (click)="openEditBlueprintJsonDialog($event, blueprint, true)">
                            <mat-icon class="icon">search</mat-icon>
                        </button>
                    }

                    @if (blueprint.status.__typename === 'Draft') {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'blueprintList.tooltips.editVariantsJson' | translate"
                                (click)="openEditVariantsJsonDialog($event, blueprint)">
                            <mat-icon class="icon">data_array</mat-icon>
                        </button>
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'blueprintList.tooltips.editVariantsForm' | translate"
                                (click)="openEditVariantsFormDialog($event, blueprint)">
                            <mat-icon class="icon">edit_note</mat-icon>
                        </button>
                    } @else {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'blueprintList.tooltips.viewVariants' | translate"
                                (click)="openEditVariantsJsonDialog($event, blueprint, true)">
                            <mat-icon class="icon">notes</mat-icon>
                        </button>
                    }

                    @if (blueprint.status.__typename === 'Draft') {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'blueprintList.tooltips.editRules' | translate: {ruleType: 'event' }"
                                (click)="openEditEventsDialog($event, blueprint, 'event', false)">
                            <mat-icon class="icon">terminal</mat-icon>
                        </button>
                    } @else {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'blueprintList.tooltips.viewRules' | translate: {ruleType: 'event' }"
                                (click)="openEditEventsDialog($event, blueprint, 'event', true)">
                            <mat-icon class="icon">web_asset</mat-icon>
                        </button>
                    }

                    @if (blueprint.status.__typename === 'Draft') {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'blueprintList.tooltips.editRules' | translate : {ruleType: 'invariant' }"
                                (click)="openEditEventsDialog($event, blueprint, 'invariant', false)">
                            <mat-icon class="icon">terminal</mat-icon>
                        </button>
                    } @else {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'blueprintList.tooltips.viewRules' | translate: {ruleType: 'invariant' }"
                                (click)="openEditEventsDialog($event, blueprint, 'invariant', true)">
                            <mat-icon class="icon">web_asset</mat-icon>
                        </button>
                    }

                    @if (blueprint.status.__typename === 'Draft') {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'blueprintList.tooltips.asset' | translate"
                                (click)="fileInput.click()">
                            <mat-icon class="icon">upload_file</mat-icon>
                            <input #fileInput type="file" class="file-upload" hidden
                                   (change)="assetUpload(blueprint, $event)">
                        </button>
                    }

                    @if (blueprint.featureImage) {
                        <button mat-button
                                class="table-button"
                                [matTooltip]="'blueprintList.tooltips.showFeatureImage' | translate"
                                (click)="$event.stopPropagation(); openAsset(blueprint.featureImage)">
                            <mat-icon class="icon">image</mat-icon>
                        </button>
                    }
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let blueprint" [attr.colspan]="displayedColumnsBlueprints.length">
                <div class="variants"
                     [@detailExpand]="blueprint.id === expandedBpId ? 'expanded' : 'collapsed'">
                    <table mat-table [dataSource]="expandedVariants" class="mat-elevation-z0">

                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef>{{ "variantList.column.id" | translate }}</th>
                            <td mat-cell *matCellDef="let variant" class="variant-row"> {{ variant.id }}</td>
                        </ng-container>

                        <ng-container matColumnDef="name">
                            <th mat-header-cell *matHeaderCellDef>{{ "variantList.column.name" | translate }}</th>
                            <td mat-cell *matCellDef="let variant" class="variant-row"> {{ variant.name }}</td>
                        </ng-container>

                        <ng-container matColumnDef="sku">
                            <th mat-header-cell *matHeaderCellDef>{{ "variantList.column.sku" | translate }}</th>
                            <td mat-cell *matCellDef="let variant" class="variant-row"> {{ variant.skus.length }}</td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef>{{ "variantList.column.action" | translate }}</th>
                            <td mat-cell *matCellDef="let variant" class="variant-row">
                                <div class="container">
                                    <button mat-button
                                            class="table-button"
                                            [matTooltip]="'variantList.tooltips.asset' | translate"
                                            (click)="fileInput.click()">
                                        <mat-icon class="icon">upload_file</mat-icon>
                                        <input #fileInput hidden
                                               type="file"
                                               class="file-upload"
                                               (change)="assetUpload(variant, $event)">
                                    </button>
                                    <button mat-button
                                            class="table-button"
                                            [matTooltip]="'blueprintList.tooltips.featureImage' | translate"
                                            (click)="featureImageInput.click()">
                                        <mat-icon class="icon">upload_file</mat-icon>
                                        <input #featureImageInput type="file" class="file-upload" hidden
                                               (change)="assetUpload(variant, $event, 'featureImage')">
                                    </button>

                                    @if (variant.featureImage) {
                                        <button mat-button
                                                class="table-button"
                                                [matTooltip]="'blueprintList.tooltips.showFeatureImage' | translate"
                                                (click)="$event.stopPropagation(); openAsset(variant.featureImage)">
                                            <mat-icon class="icon">image</mat-icon>
                                        </button>
                                    }
                                    <button mat-button
                                            class="table-button"
                                            [matTooltip]="'variantList.tooltips.config' | translate"
                                            (click)="makeConfigWithVariant(variant)">
                                        <mat-icon class="icon">start</mat-icon>
                                    </button>
                                </div>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsVariants"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsVariants;"></tr>

                    </table>
                </div>
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumnsBlueprints"></tr>
        <tr mat-row *matRowDef="let blueprint; columns: displayedColumnsBlueprints;"
            [ngClass]="{
                'element-row': this.statusFilter === 'Draft' && blueprint.status.__typename !== 'Published',
                'expanded-row': expandedBpId === blueprint.id,
                'read-only-row': this.statusFilter === 'Draft' && blueprint.status.__typename === 'Published'
            }"
            (click)="expandBlueprint(blueprint)">
        </tr>
        <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="detail-row"></tr>
    </table>
</div>

